// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchResponse {
    static getAttributeTypeMap() {
        return ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchResponse.attributeTypeMap;
    }
}
ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchResponse.discriminator = undefined;
ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<PharmacyClaimSearchResponseModel>"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    }
];
//# sourceMappingURL=claimV1ClaimPharmacyClaimSearchPharmacyClaimSearchResponse.js.map